<form [formGroup]="administrativeForm" (ngSubmit)="onSubmit()">
	<div class="py-5 space-y-3">
		<h5 class="!text-sm font-medium text-primary">Identité du patient - Informations Principales</h5>
		<div class="border border-solid border-gray-200 rounded overflow-hidden">
			<div class="bg-slate-50 w-full p-7 flex items-center justify-center">
				<img src="images/users/placeholder.png" alt="profile" class="w-20 h-20 rounded-full">
			</div>
			<div class="p-2 md:p-5">
				<div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
					<div class="">
						<label class="text-sm required" for="firstName">Prénom</label>
						<input type="text" id="firstName" formControlName="firstName" required
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full" placeholder="Prénom">
					</div>
					<div class="">
						<label class="text-sm required" for="lastName">Nom</label>
						<input type="text" id="lastName" formControlName="lastName" required
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full" placeholder="Nom">
					</div>
					<div class="">
						<label class="text-sm required" for="dateOfBirth">Date de naissance</label>
						<input type="date" id="dateOfBirth" formControlName="dateOfBirth" required
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full" placeholder="Date de naissance">
					</div>
					<div class="">
						<label class="text-sm" for="age">Age</label>
						<input type="number" id="age" formControlName="age" readonly
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full !bg-gray-100 !text-gray-400 cursor-not-allowed"
							placeholder="Age">
					</div>
					<div>
						<label class="text-sm required" for="sex">Sexe</label>
						<select id="sex" formControlName="sex" required
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full">
							<option value="" disabled selected>Choisir le sexe</option>
							@for (option of sexOptions; track option.value) {
							<option [value]="option.value">{{ option.label }}</option>
							}
						</select>
					</div>
					<div class="">
						<label class="text-sm" for="placeOfBirth">Lieu de naissance</label>
						<input type="text" id="placeOfBirth" formControlName="placeOfBirth"
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full" placeholder="Lieu de naissance">
					</div>
					<div class="lg:col-span-2">
						<label class="text-sm required" for="phone">Téléphone</label>
						<input type="text" id="phone" formControlName="phone" readonly
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full !bg-gray-100 !text-gray-400 cursor-not-allowed"
							placeholder="Téléphone">
					</div>
					<div class="lg:col-span-2 z-20">
						<label class="text-sm" for="landline">Téléphone fixe</label>
						<angular-phone-number-input id="landline" formControlName="landline" [defaultCountry]="'SN'" [border]="true"
							(ngModelChange)="onPhoneInputChange($event)" class="w-full !h-[40px]">
						</angular-phone-number-input>
					</div>
					<div class="lg:col-span-2">
						<label class="text-sm" for="email">Email</label>
						<input type="email" id="email" formControlName="email" readonly
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full !bg-gray-100 !text-gray-400 cursor-not-allowed"
							placeholder="Email">
					</div>
					<div>
						<label class="text-sm" for="maritalStatus">Situation matrimoniale</label>
						<select id="maritalStatus" formControlName="maritalStatus"
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full">
							<option value="" disabled selected>Choisir la situation</option>
							@for (option of maritalStatusOptions; track option.value) {
							<option [value]="option.value">{{ option.label }}</option>
							}
						</select>
					</div>
					<div>
						<label class="text-sm" for="bloodGroup">Groupe sanguin</label>
						<select id="bloodGroup" formControlName="bloodGroup"
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full">
							<option value="" disabled selected>Choisir le groupe sanguin</option>
							@for (option of bloodGroupOptions; track option.value) {
							<option [value]="option.value">{{ option.label }}</option>
							}
						</select>
					</div>
					<div>
						<label class="text-sm" for="weight">Poids (kg)</label>
						<input type="number" id="weight" formControlName="weight"
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full" placeholder="Poids">
					</div>
					<div>
						<label class="text-sm" for="height">Taille (m)</label>
						<input type="text" id="height" formControlName="height" inputmode="decimal"
							class="input placeholder:text-[12px] placeholder:text-slate-400 w-full" placeholder="Ex: 1,75">
					</div>
				</div>
			</div>
		</div>
	</div>


	<div class="py-5 space-y-3">
		<h5 class="!text-sm font-medium text-primary">
			Adresse actuelle
		</h5>
		<div class="border border-solid border-gray-200 rounded overflow-hidden p-5">
			<div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
				<div class="lg:col-span-2">
					<label class="text-sm" for="currentCountry">Pays</label>
					<select id="currentCountry" formControlName="currentCountry"
						class="input placeholder:text-[12px] placeholder:text-slate-400 w-full">
						<option value="" disabled selected>Choisir le pays</option>
						@for (option of countryOptions; track option.value) {
						<option [value]="option.value">{{ option.label }}</option>
						}
					</select>
				</div>
				<div>
					<label class="text-sm" for="currentRegion">Région</label>
					<select id="currentRegion" formControlName="currentRegion"
						class="input placeholder:text-[12px] placeholder:text-slate-400 w-full">
						<option value="" disabled selected>Choisir la région</option>
						@for (option of regionOptions; track option.value) {
						<option [value]="option.value">{{ option.label }}</option>
						}
					</select>
				</div>
				<div>
					<label class="text-sm" for="currentDepartment">Département</label>
					<select id="currentDepartment" formControlName="currentDepartment"
						class="input placeholder:text-[12px] placeholder:text-slate-400 w-full">
						<option value="" disabled selected>Choisir le département</option>
						@for (option of departmentOptions; track option.value) {
						<option [value]="option.value">{{ option.label }}</option>
						}
					</select>
				</div>
				<div>
					<label class="text-sm" for="currentCommune">Commune</label>
					<input type="text" id="currentCommune" formControlName="currentCommune"
						class="input placeholder:text-[12px] placeholder:text-slate-400 w-full" placeholder="Commune">
				</div>
				<div>
					<label class="text-sm" for="currentDistrict">Quartier/Village</label>
					<input type="text" id="currentDistrict" formControlName="currentDistrict"
						class="input placeholder:text-[12px] placeholder:text-slate-400 w-full" placeholder="Quartier/Village">
				</div>
			</div>
		</div>
	</div>
	<div class="py-5 space-y-3">
		<h5 class="!text-sm font-medium text-primary">
			Adresse habituelle
		</h5>
		<div class="border border-solid border-gray-200 rounded overflow-hidden p-5">
			<div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
				<div class="lg:col-span-2">
					<label class="text-sm" for="usualCountry">Pays</label>
					<select id="usualCountry" formControlName="usualCountry"
						class="input placeholder:text-[12px] placeholder:text-slate-400 w-full">
						<option value="" disabled selected>Choisir le pays</option>
						@for (option of countryOptions; track option.value) {
						<option [value]="option.value">{{ option.label }}</option>
						}
					</select>
				</div>
				<div>
					<label class="text-sm" for="usualRegion">Région</label>
					<select id="usualRegion" formControlName="usualRegion"
						class="input placeholder:text-[12px] placeholder:text-slate-400 w-full">
						<option value="" disabled selected>Choisir la région</option>
						@for (option of regionOptions; track option.value) {
						<option [value]="option.value">{{ option.label }}</option>
						}
					</select>
				</div>
				<div>
					<label class="text-sm" for="usualDepartment">Département</label>
					<select id="usualDepartment" formControlName="usualDepartment"
						class="input placeholder:text-[12px] placeholder:text-slate-400 w-full">
						<option value="" disabled selected>Choisir le département</option>
						@for (option of departmentOptions; track option.value) {
						<option [value]="option.value">{{ option.label }}</option>
						}
					</select>
				</div>
				<div>
					<label class="text-sm" for="usualCommune">Commune</label>
					<input type="text" id="usualCommune" formControlName="usualCommune"
						class="input placeholder:text-[12px] placeholder:text-slate-400 w-full" placeholder="Commune">
				</div>
				<div>
					<label class="text-sm" for="usualDistrict">Quartier/Village</label>
					<input type="text" id="usualDistrict" formControlName="usualDistrict"
						class="input placeholder:text-[12px] placeholder:text-slate-400 w-full" placeholder="Quartier/Village">
				</div>
			</div>
		</div>
	</div>

	<div class="py-5 space-y-3">
		<h5 class="!text-sm font-medium text-primary">
			Identité du patient - Informations Complémentaires
		</h5>
		<div class="border border-solid border-gray-200 rounded overflow-hidden p-5">
			<div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
				<div>
					<label class="text-sm" for="educationLevel">Niveau d'instruction et formation</label>
					<select id="educationLevel" formControlName="educationLevel"
						class="input placeholder:text-[12px] placeholder:text-slate-400 w-full">
						<option value="" disabled selected>Choisir le niveau d'instruction</option>
						@for (option of educationLevelOptions; track option.value) {
						<option [value]="option.value">{{ option.label }}</option>
						}
					</select>
				</div>
				<div>
					<label class="text-sm" for="profession">Profession du patient</label>
					<select id="profession" formControlName="profession"
						class="input placeholder:text-[12px] placeholder:text-slate-400 w-full">
						<option value="" disabled selected>Choisir la profession</option>
						@for (option of professionOptions; track option.value) {
						<option [value]="option.value">{{ option.label }}</option>
						}
					</select>
				</div>
				<div>
					<label class="text-sm" for="nationality">Nationalité</label>
					<select id="nationality" formControlName="nationality"
						class="input placeholder:text-[12px] placeholder:text-slate-400 w-full">
						<option value="" disabled selected>Choisir la nationalité</option>
						@for (option of nationalityOptions; track option.value) {
						<option [value]="option.value">{{ option.label }}</option>
						}
					</select>
				</div>
				<div>
					<label class="text-sm" for="ethnicity">Ethnie</label>
					<select id="ethnicity" formControlName="ethnicity"
						class="input placeholder:text-[12px] placeholder:text-slate-400 w-full">
						<option value="" disabled selected>Choisir l'ethnie</option>
						@for (option of ethnicityOptions; track option.value) {
						<option [value]="option.value">{{ option.label }}</option>
						}
					</select>
				</div>

			</div>
		</div>
	</div>

	<div class="pt-5 flex items-center justify-center">
		<button type="submit"
			class="!text-sm text-white px-7 py-2 rounded-md bg-primary disabled:opacity-50 disabled:cursor-not-allowed"
			[disabled]="!administrativeForm.valid || loading">
			<span *ngIf="loading" class="inline-flex items-center">
				<svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
					<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
					<path class="opacity-75" fill="currentColor"
						d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
					</path>
				</svg>
				Enregistrement...
			</span>
			<span *ngIf="!loading">Enregistrer les changements</span>
		</button>
	</div>
</form>
